// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-input-wrap {
  position: relative;
  display: inline-block;
}

.time-input-label {
  display: flex;
  align-items: center;
}

.timepicker-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.time-pickable {
  appearance: none;
  outline: none;
  border: 1px solid #dddddd;
  border-radius: 6px;
  padding: 6px 10px;
  background: #ffffff;
  cursor: pointer;
  font-family: "Heebo", sans-serif;
}

.time-picker__select {
  appearance: none;
  outline: none;
  text-align: center;
  border: 1px solid #dddddd;
  border-radius: 6px;
  padding: 6px 10px;
  background: #ffffff;
  cursor: pointer;
  margin-right: 5px;
  margin-left: 5px;
}

.time-input-wrap img {
  position: absolute;
  width: 35px;
  height: 35px;
  top: 10px;
  left: 4px;
  z-index: 99;
  cursor: pointer;
}

.time-input-wrap p {
  position: absolute;
  left: 42px;
  top: 10px;
  font-size: 12px;
  color: #626262;
  font-weight: 400;
}

.time-input-wrap input::placeholder {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
}

.date-input-wrap:hover input {
  border: 1px solid #00a19b;
}

.time-input-wrap:hover input {
  border: 1px solid #00a19b;
}

input.time-pickable.desabled {
  opacity: 0.7;
  filter: grayscale(100%);
  cursor: no-drop;
}

input.time-pickable.desabled::placeholder {
  opacity: 0.6;
}

.time-input-wrap:hover input.time-pickable.desabled:hover {
  border: 1px solid #dddddd;
}

.time-picker {
  position: absolute;
  width: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.time-picker {
  position: absolute;
  z-index: 999;
  background-color: white;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
}

.time-picker.open-up {
  top: 100%;
  bottom: auto;
}

.time-picker.open-down {
  bottom: 100%;
  top: auto;
}

.time-option {
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.time-option:hover {
  background-color: #f0f0f0;
}

input.time-pickable.disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

input.time-pickable.disabled::placeholder {
  opacity: 0.4;
}

.time-input-wrap:hover input.time-pickable.disabled {
  border: 1px solid #f3f3f3;
}

/************* Address input css ****/
.address-input-wrapper {
  position: relative;
}

.autocomplete-dropdown-container {
  width: 100%;
  cursor: pointer;
  z-index: 9999;
  border-radius: 9px;
  background: #ffffff;
  position: absolute;
  top: 66px;
  left: 0;
  opacity: 1;
  max-height: 50vh;
  padding: 20px 10px;
  overflow: auto;
  border: 1px solid #00a19b;
}

.suggestion-item {
  /* padding: 8px; */
  padding-left: 15px;
  padding-right: 15px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  color: #333333 !important;
  font-weight: 400;
}

.discount-filed-wrap p {
  color: #ff0000 !important;
}

@media (max-width: 1024px) {
  .suggestion-item {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 400;
  }
}

@media (min-width: 1025px) and (max-width: 1199px) {
  .time-input-wrap p {
    top: 6px;
    font-size: 10px;
  }

  .time-input-wrap input::placeholder {
    font-size: 12px;
    color: #1a1919;
    font-weight: 400;
  }
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .time-input-wrap p {
    top: 6px;
    font-size: 10px;
  }

  .time-input-wrap input::placeholder {
    font-size: 12px;
    color: #1a1919;
    font-weight: 400;
  }

  .autocomplete-dropdown-container {
    top: 50px;
  }

  .suggestion-item {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
  }

  .time-option {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
  }

  .time-input-wrap img {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 12px;
    left: 0px;
  }

  .date-input-wrap img {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 12px;
    left: 0px;
}

  .custom-date-input p {
    left: 32px;
  }

  .time-input-wrap p {
    left: 32px;
  }
  
  .date-and-time-wrapper input {
    padding-left: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/components/TimePicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EAGE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EAGE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;AACb;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".time-input-wrap {\n  position: relative;\n  display: inline-block;\n}\n\n.time-input-label {\n  display: flex;\n  align-items: center;\n}\n\n.timepicker-icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n}\n\n.time-pickable {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  outline: none;\n  border: 1px solid #dddddd;\n  border-radius: 6px;\n  padding: 6px 10px;\n  background: #ffffff;\n  cursor: pointer;\n  font-family: \"Heebo\", sans-serif;\n}\n\n.time-picker__select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  outline: none;\n  text-align: center;\n  border: 1px solid #dddddd;\n  border-radius: 6px;\n  padding: 6px 10px;\n  background: #ffffff;\n  cursor: pointer;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.time-input-wrap img {\n  position: absolute;\n  width: 35px;\n  height: 35px;\n  top: 10px;\n  left: 4px;\n  z-index: 99;\n  cursor: pointer;\n}\n\n.time-input-wrap p {\n  position: absolute;\n  left: 42px;\n  top: 10px;\n  font-size: 12px;\n  color: #626262;\n  font-weight: 400;\n}\n\n.time-input-wrap input::placeholder {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n}\n\n.date-input-wrap:hover input {\n  border: 1px solid #00a19b;\n}\n\n.time-input-wrap:hover input {\n  border: 1px solid #00a19b;\n}\n\ninput.time-pickable.desabled {\n  opacity: 0.7;\n  filter: grayscale(100%);\n  cursor: no-drop;\n}\n\ninput.time-pickable.desabled::placeholder {\n  opacity: 0.6;\n}\n\n.time-input-wrap:hover input.time-pickable.desabled:hover {\n  border: 1px solid #dddddd;\n}\n\n.time-picker {\n  position: absolute;\n  width: 100%;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.time-picker {\n  position: absolute;\n  z-index: 999;\n  background-color: white;\n  border: 1px solid #ccc;\n  max-height: 200px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.time-picker.open-up {\n  top: 100%;\n  bottom: auto;\n}\n\n.time-picker.open-down {\n  bottom: 100%;\n  top: auto;\n}\n\n.time-option {\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.time-option:hover {\n  background-color: #f0f0f0;\n}\n\ninput.time-pickable.disabled {\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\ninput.time-pickable.disabled::placeholder {\n  opacity: 0.4;\n}\n\n.time-input-wrap:hover input.time-pickable.disabled {\n  border: 1px solid #f3f3f3;\n}\n\n/************* Address input css ****/\n.address-input-wrapper {\n  position: relative;\n}\n\n.autocomplete-dropdown-container {\n  width: 100%;\n  cursor: pointer;\n  z-index: 9999;\n  border-radius: 9px;\n  background: #ffffff;\n  position: absolute;\n  top: 66px;\n  left: 0;\n  opacity: 1;\n  max-height: 50vh;\n  padding: 20px 10px;\n  overflow: auto;\n  border: 1px solid #00a19b;\n}\n\n.suggestion-item {\n  /* padding: 8px; */\n  padding-left: 15px;\n  padding-right: 15px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  font-size: 16px;\n  color: #333333 !important;\n  font-weight: 400;\n}\n\n.discount-filed-wrap p {\n  color: #ff0000 !important;\n}\n\n@media (max-width: 1024px) {\n  .suggestion-item {\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-bottom: 10px;\n    font-size: 15px;\n    font-weight: 400;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1199px) {\n  .time-input-wrap p {\n    top: 6px;\n    font-size: 10px;\n  }\n\n  .time-input-wrap input::placeholder {\n    font-size: 12px;\n    color: #1a1919;\n    font-weight: 400;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1599px) {\n  .time-input-wrap p {\n    top: 6px;\n    font-size: 10px;\n  }\n\n  .time-input-wrap input::placeholder {\n    font-size: 12px;\n    color: #1a1919;\n    font-weight: 400;\n  }\n\n  .autocomplete-dropdown-container {\n    top: 50px;\n  }\n\n  .suggestion-item {\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-bottom: 10px;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .time-option {\n    padding: 8px 12px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .time-input-wrap img {\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    top: 12px;\n    left: 0px;\n  }\n\n  .date-input-wrap img {\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    top: 12px;\n    left: 0px;\n}\n\n  .custom-date-input p {\n    left: 32px;\n  }\n\n  .time-input-wrap p {\n    left: 32px;\n  }\n  \n  .date-and-time-wrapper input {\n    padding-left: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
